import * as React from 'react';
import moment from "moment";
import {MOMENT_TIME_FORMAT} from "../../utils/date-utils";

interface TimeViewProps {
  time: moment.Moment;
}

class TimeView extends React.Component<TimeViewProps, any> {

  public render(): React.ReactNode {
    const {time} = this.props;
    return (
      <div className="calendar-time-view-parent">
        <div className="calendar-time-view">
          {time.format(MOMENT_TIME_FORMAT)}
        </div>
      </div>
    );
  }
}

export default TimeView;


// WEBPACK FOOTER //
// ./src/event/view/TimeView.tsx